import(/* webpackMode: "eager" */ "/home/runner/work/SOFAR/SOFAR/app/dashboard/page.jsx");
